<div class="intro-container">
  <ng-content></ng-content>
</div>
